import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "./Header"; // keep path
import Footer from './Footer';
import HomepagePricingSection from './HomepagePricingSection';
import { FaLinkedinIn } from 'react-icons/fa';

// ==== ICONS (unchanged APIs so your code elsewhere still works) ====
const CheckCircle = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);
const Star = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);
const Rocket = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.3.05-3.12-.65-.82-2.17-1.43-3.12-1.88z" /><path d="M12 15.5V13a2 2 0 0 0-2-2H8.5" /><path d="M16 10.5a5.5 5.5 0 0 0-5.5-5.5" /><path d="M12 2.5a2.5 2.5 0 0 1 2.5 2.5" /><path d="M19 13a2.5 2.5 0 0 1 2.5 2.5" /><path d="M19 19.5a5.5 5.5 0 0 0-5.5-5.5" /><path d="M21.5 4.5c-1.26 1.5-5 2-5 2s.5 3.74 2 5c.84.71 2.3.7 3.12.05.82-.65 1.43-2.17 1.88-3.12z" />
  </svg>
);
const UserCheck = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><polyline points="16 11 18 13 22 9" />
  </svg>
);
const TrendingUp = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" /><polyline points="16 7 22 7 22 13" />
  </svg>
);
const Mail = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
);
const Bot = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M12 8V4H8" /><rect width="16" height="12" x="4" y="8" rx="2" /><path d="M2 14h2" /><path d="M20 14h2" /><path d="M15 13v2" /><path d="M9 13v2" />
  </svg>
);
const Mic = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" /><path d="M19 10v2a7 7 0 0 1-14 0v-2" /><line x1="12" x2="12" y1="19" y2="22" />
  </svg>
);
const FileText = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" /><polyline points="14 2 14 8 20 8" /><line x1="16" x2="8" y1="13" y2="13" /><line x1="16" x2="8" y1="17" y2="17" /><line x1="10" x2="8" y1="9" y2="9" />
  </svg>
);
const Target = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" />
  </svg>
);
const Workflow = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <rect width="8" height="8" x="3" y="3" rx="2" /><path d="M7 11v4a2 2 0 0 0 2 2h4" /><rect width="8" height="8" x="13" y="13" rx="2" />
  </svg>
);
const ArrowRight = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
  </svg>
);
const Twitter = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M22 4s-.7 2.1-2 3.4c1.6 1.4 2.8 3.2 3 5.2-1.4 1-3.2 1.9-5 2.4-2.2 2.8-5.3 3.9-9 3.4-3.4-.5-6-2.4-7.4-5.2-3-7.9 1.5-13.4 8.5-13.2 3.8.1 6.8 1.4 9 3.2z" /></svg>
);
const Linkedin = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" /><rect x="2" y="9" width="4" height="12" /><circle cx="4" cy="4" r="2" /></svg>
);

// ======== UTIL: in-view animation ========
const useOnScreen = (options) => {
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setIsVisible(true); obs.unobserve(ref.current); }
    }, options);
    if (ref.current) obs.observe(ref.current);
    return () => { if (ref.current) obs.unobserve(ref.current); };
  }, [ref, options]);
  return [ref, isVisible];
};
const AnimatedSection = ({ children, className, id }) => {
  const [ref, isVisible] = useOnScreen({ threshold: 0.1 });
  return (
    <section ref={ref} id={id} className={`${className} transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>{children}</section>
  );
};

// ======== CONTENT (same objects so no logic breaks) ========
const hero = {
  tagline: "Transform Your Business’s Outreach Strategy with AI",
  subheading: "Connect with leads, build relationships, and drive growth like never before. Roboman is your intelligent partner for personalized, effective outreach campaigns.",
  ctaPrimary: "Starts with 100 Free Credits",
  ctaSecondary: "See a Demo",
  ctaNote: "Explore all features with 100 free credits. No payment required.",
};

// const hero = {
//   tagline: "Deliver More Client Meetings—Without More Headcount",
//   subheading:
//     "Roboman helps agencies run personalized outreach across email, LinkedIn, voice notes, and proposals. Intent scoring prioritizes hot leads so your team focuses where it converts.",
//   ctaPrimary: "Start Free — 100 Credits",
//   ctaSecondary: "Book a Demo",
//   ctaNote: "Perfect for client campaigns, reporting, and repeatable playbooks.",
// };

const benefits = {
  items: [
    { id: 1, icon: TrendingUp, title: "Boost Reply Rates", text: "Leverage AI to craft hyper-personalized messages that resonate and get responses." },
    { id: 2, icon: UserCheck, title: "Qualify Leads Faster", text: "Our system analyzes lead profiles to identify your most promising prospects automatically." },
    { id: 3, icon: Rocket, title: "Scale Your Outreach", text: "Reach thousands of potential customers without sacrificing the personal touch." }
  ]
};
const featuresContent = [
  { id: 1, Icon: Mail, title: "AI Email Crafting", description: "Generate compelling, personalized email sequences in seconds. Overcome writer's block forever.", bgColor: "bg-blue-100", iconColor: "text-blue-600" },
  { id: 2, Icon: Bot, title: "Automated Follow-ups", description: "Never let a lead slip through the cracks. Roboman intelligently follows up based on engagement.", bgColor: "bg-green-100", iconColor: "text-green-600" },
  { id: 3, Icon: UserCheck, title: "Lead Enrichment", description: "Automatically find and verify contact information, adding valuable context to your outreach.", bgColor: "bg-purple-100", iconColor: "text-purple-600" },
  { id: 4, Icon: Mic, title: "Multilingual Voice Cloning", description: "Clone your voice once. Deliver personalized voice notes in any language across the globe to build real connections.", bgColor: "bg-red-100", iconColor: "text-red-600" },
  { id: 5, Icon: FileText, title: "AI Proposal Generation", description: "Our AI crafts tailored proposals and presentations that pinpoint gaps, highlight ROI, and close deals faster.", bgColor: "bg-yellow-100", iconColor: "text-yellow-600" },
  { id: 6, Icon: Target, title: "Buying Intent Scoring", description: "Our AI ranks every lead by their buying intent, so your time and energy flow exactly where the results are.", bgColor: "bg-indigo-100", iconColor: "text-indigo-600" },
  { id: 7, Icon: Workflow, title: "Autopilot Sequences", description: "From voice notes to LinkedIn messages and proposals, Autopilot ensures no lead slips through the cracks.", bgColor: "bg-pink-100", iconColor: "text-pink-600" },
  {id: 8, Icon: Linkedin, title: "LinkedIn Ghostwriter",description: "Automate personalized connection requests and follow-ups that sound like you, ensuring every interaction feels authentic and human.", bgColor: "bg-blue-100",iconColor: "text-blue-600"},
];
const testimonials = {
  items: [
    { id: 1, name: "Sarah L.", role: "Marketing Director @ TechCorp", feedback: "Roboman has been a game-changer for our lead generation. We've seen a 3x increase in qualified meetings since we started.", avatarUrl: "https://placehold.co/100x100/f0abfc/4a044e?text=SL", rating: 5 },
    { id: 2, name: "David Chen", role: "Founder, StartupX", feedback: "As a small team, we need to be efficient. The automation and AI save us at least 10 hours a week. It's indispensable.", avatarUrl: "https://placehold.co/100x100/93c5fd/1e3a8a?text=DC", rating: 5 },
    { id: 3, name: "Maria Garcia", role: "Sales Manager", feedback: "The personalization is what sets Roboman apart. It doesn't feel like an automated email, and our prospects notice that.", avatarUrl: "https://placehold.co/100x100/a7f3d0/052e16?text=MG", rating: 5 }
  ]
};
const pricingData = {
  currencies: [
    { id: 'USD', symbol: '$', name: 'USA (USD)' },
    { id: 'GBP', symbol: '£', name: 'UK (GBP)' },
    { id: 'CAD', symbol: 'C$', name: 'Canada (CAD)' },
    { id: 'AUD', symbol: 'A$', name: 'Australia (AUD)' },
    { id: 'INR', symbol: '₹', name: 'India (INR)' },
  ],
  plans: [
    { id: 1, title: "Starter", credits: "500", prices: { INR: "3,499", USD: "49", GBP: "39.99", CAD: "69.99", AUD: "79.99" }, vat: { GBP: true }, features: ["50 Companies OR", "20 Business Proposals", "100 Voice Notes", "250 Emails/Messages"], mixExample: { title: "Mix Example:", items: ["20 intent signals", "50 emails", "30 voice notes", "2 proposals"] }, recommended: false },
    { id: 2, title: "Growth", credits: "1,000", prices: { INR: "6,999", USD: "99", GBP: "79.99", CAD: "139.99", AUD: "159.99" }, vat: { GBP: true }, features: ["100 Companies OR", "40 Business Proposals", "200 Voice Notes", "500 Emails/Messages"], mixExample: { title: "Mix Example:", items: ["40 intent signals", "100 emails", "60 voice notes", "4 proposals"] }, recommended: true },
    { id: 3, title: "Pro", credits: "2,000", prices: { INR: "13,999", USD: "199", GBP: "159.99", CAD: "279.99", AUD: "319.99" }, vat: { GBP: true }, features: ["200 Companies OR", "80 Business Proposals", "400 Voice Notes", "1000 Emails/Messages"], mixExample: { title: "Mix Example:", items: ["80 intent signals", "200 emails", "120 voice notes", "8 proposals"] }, recommended: false },
    { id: 4, title: "Enterprise", credits: "Custom", prices: { INR: "Custom", USD: "Custom", GBP: "Custom", CAD: "Custom", AUD: "Custom" }, priceInfo: "Starts at $499+", features: ["Custom Credit Amount", "Dedicated Account Manager", "API Access & Support", "Custom Onboarding & Training"], recommended: false }
  ]
};
const finalCta = {
  prompt: "Ready to Revolutionize Your Outreach?",
  buttonText: "Claim Your 100 Free Credits Trial to Start Today",
  note: "No credit card required. Explore all features with 100 free credits."
};

// ======== UNIQUE VISUALS ========
const NeonCard = ({ children, className = '' }) => (
  <div className={`relative rounded-2xl p-[1px] bg-gradient-to-b from-indigo-500/30 via-fuchsia-500/20 to-purple-500/30 shadow-[0_0_0_1px_rgba(99,102,241,0.08)] ${className}`}>
    <div className="rounded-2xl bg-white/80 backdrop-blur-xl p-6">
      {children}
    </div>
  </div>
);

const Ribbon = ({ text }) => (
  <div className="absolute -top-3 left-4 inline-flex items-center gap-2 rounded-full bg-slate-900 text-slate-100 px-3 py-1 text-[11px] font-semibold shadow-lg">
    <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse" /> {text}
  </div>
);

const Marquee = ({ items }) => (
  <div className="relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
    <div className="flex gap-8 animate-[scroll_28s_linear_infinite] will-change-transform">
      {[...items, ...items, ...items].map((it, i) => (
        <span key={i} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/80 ring-1 ring-slate-200 text-slate-700 text-sm font-medium">
          <CheckCircle className="h-4 w-4 text-emerald-500" /> {it}
        </span>
      ))}
    </div>
  </div>
);

// ======== PAGE ========
const HomePage = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState('USD');
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleScheduleClick = () => {
    window.Calendly?.initPopupWidget({ url: 'https://calendly.com/priyeshsharad/roboman' });
  };

  return (
    <div className="bg-white text-slate-800 font-sans antialiased">
      {/* Page-only CSS (no deps) */}
      <style>{`
       body, html {
       overflow-x: hidden;
       max-width: 100vw;
      }

        .grid-bg { background-image: radial-gradient(circle at 1px 1px, rgba(15,23,42,.08) 1px, transparent 0); background-size: 24px 24px; }
        @keyframes floaty { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-8px)} }
        @keyframes blob { 0%{transform:translate(0,0) scale(1);} 33%{transform:translate(20px,-10px) scale(1.05);} 66%{transform:translate(-10px,14px) scale(.98);} 100%{transform:translate(0,0) scale(1);} }
        @keyframes scroll { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .tilt:hover { transform: perspective(800px) rotateX(3deg) rotateY(-6deg) translateY(-2px); }
      `}</style>

      <Header isScrolled={isScrolled} />

      <main className="overflow-hidden max-w-full " >
        {/* ===== HERO (split, with neon device stack) ===== */}
        <section className="relative isolate pt-24 pb-20 overflow-hidden ">
          <div className="absolute inset-0 -z-10 bg-gradient-to-b from-indigo-50 via-white to-white  " />
          <div className="absolute -top-40 -left-24 h-[32rem] w-[32rem] bg-fuchsia-300/30 blur-3xl rounded-full mix-blend-multiply animate-[blob_12s_ease-in-out_infinite]" />
          <div className="absolute -top-48 -right-24 h-[36rem] w-[36rem] bg-indigo-300/30 blur-3xl rounded-full mix-blend-multiply animate-[blob_16s_ease-in-out_infinite]" />

          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ">
            <div className="grid  grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-center">
              {/* Copy */}

              {/* left column */}
              <div className="lg:col-span-6 ">
                <span className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1 text-xs font-semibold ring-1 ring-slate-200">
                  <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 animate-pulse" />
                  New: Voice Notes in Autopilot
                </span>

                <h1 className="mt-4 text-3xl sm:text-4xl  md:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900">
                  {hero.tagline}
                </h1>

                <p className="mt-6 text-base sm:text-lg text-slate-600 max-w-xl">
                  {hero.subheading}
                </p>

                <div className="mt-8 flex flex-col sm:flex-row flex-wrap gap-3">
                  <button onClick={() => navigate('/signup')}
                    className="inline-flex items-center justify-center  gap-2 rounded-full bg-slate-900 text-white px-6 py-3 font-semibold shadow-lg hover:bg-slate-800 transition-all hover:scale-[1.02]"
                  >
                    {hero.ctaPrimary} <ArrowRight className="h-5 w-5" />
                  </button>

                  <button onClick={handleScheduleClick}
                    className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-6 py-3 font-semibold text-slate-900 ring-1 ring-slate-200 shadow-md hover:bg-slate-50">
                    {hero.ctaSecondary}
                  </button>
                </div>
                <p className="mt-3 text-xs text-slate-500">{hero.ctaNote}</p>

                {/* marquee */}
                <div className="mt-8">
                  <Marquee items={['AI Emails', 'LinkedIn steps', 'Voice notes', 'Proposals', 'Intent scoring', 'CRM sync']} />
                </div>
              </div>


              {/* Right column */}
              {/* Visual stack */}
              <div className="lg:col-span-6 w-full">
                <div className="relative mx-auto max-w-xl">
                  <div className="absolute -inset-6 -z-10 rounded-[2rem] bg-gradient-to-br from-indigo-500/20 via-fuchsia-500/20 to-purple-500/20 blur-2xl" />

                  <div className="space-y-4 sm:space-y-6">

                    {/* Card 1 */}
                    <NeonCard className="tilt transition-transform">
                      <Ribbon text="Inbox-ready Emails" />


                      <div className="flex item-start sm:items-center gap-3 sm:gap-4 sm:flex-row">
                        <div className="h-10 w-10 flex-shrink-0 rounded-xl bg-blue-100 flex items-center justify-center ring-1 ring-black/5">
                          <Mail className="h-5 w-5 text-blue-600" />
                        </div>
                        <div className='flex-1'>
                          <p className="text-slate-900 font-semibold text-sm sm:text-base">
                            AI Email Crafting
                          </p>
                          <p className="text-slate-600 text-sm sm:text-sm">
                            Sequences that sound human—generated in seconds.
                          </p>
                        </div>
                      </div>
                    </NeonCard>

                    {/* Card 2 */}

                    <NeonCard className="tilt transition-transform">
                      <Ribbon text="Multichannel Autopilot" />

                      <div className="grid grid-cols-4 gap-2 sm:gap-2">
                        {['Email', 'LinkedIn', 'Voice', 'Proposal'].map((t, i) => (
                          <div key={i} className="rounded-xl bg-white ring-1 ring-slate-200 sm:p-3 text-center">
                            <p className="text-[10px] sm:text-xs font-semibold text-slate-700">{t}</p>
                            <p className="mt-1 sm:mt-2 text-[9px] sm:text-[11px] text-emerald-600 font-bold">
                              Active
                            </p>
                          </div>
                        ))}
                      </div>
                    </NeonCard>

                    {/* Card 3 */}
                    <NeonCard className="tilt transition-transform">
                      <Ribbon text="Buying Intent 9.4/10" />


                      <div className="flex flex-start sm:items-center justify-between gap-3 flex-col sm:flex-row">
                        <div className="flex items-center gap-3 flex-1">
                          <div className="h-10 w-10 flex-shrink-0 rounded-xl bg-indigo-100 flex items-center justify-center ring-1 ring-black/5">
                            <Target className="h-5 w-5 text-indigo-600" />
                          </div>
                          <div className='flex-1'>
                            <p className="text-slate-900 font-semibold text-sm sm:text-base">
                              Hot leads highlighted
                            </p>
                            <p className="text-slate-600 text-xs sm:text-sm">
                              Prioritize time where it converts.
                            </p>
                          </div>
                        </div>
                        <div className="h-10 w-20 sm:w-24  flex-shrink-0 rounded-full grid-bg flex items-center justify-center text-slate-900 text-sm font-bold">
                          +11%
                        </div>
                      </div>
                    </NeonCard>
                  </div>
                </div>
              </div>
            </div>

            {/* trust chips */}
            <div className="mt-14">
              <p className="text-center text-[11px] font-semibold tracking-widest text-slate-500">
                TRUSTED BY MODERN GTM TEAMS
              </p>
              <div className="mt-4 mx-auto max-w-5xl grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
                {['TechCorp', 'StartupX', 'InnovateCo', 'Growth Inc.', 'ScaleUp', 'Nimbus'].map((n, i) => (
                  <div key={i} className="h-10 rounded-xl bg-white ring-1 ring-slate-200 flex items-center justify-center text-slate-600 font-semibold text-xs">
                    {n}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ===== BENEFITS (as asym grid) ===== */}
        <AnimatedSection className="py-24 bg-slate-50" id="benefits">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl">
              <h2 className="text-3xl font-extrabold tracking-tight text-slate-900">Why teams pick Roboman</h2>
              <p className="mt-3 text-slate-600">Outreach that looks handcrafted—delivered at scale.</p>
            </div>
            <div className="mt-12 grid md:grid-cols-3 gap-6  ">
              {benefits.items.map((b) => {
                const Icon = b.icon; return (
                  <div key={b.id} className="relative rounded-2xl p-[1px] bg-gradient-to-b from-slate-200/60 to-white shadow-md hover:shadow-xl hover:border-b-violet-600 border-[1px] transition-transform duration-300">
                    <div className="rounded-2xl bg-white p-6 h-full">
                      <div className="h-12 w-12 rounded-xl bg-indigo-100 text-indigo-600 flex items-center justify-center ring-1 ring-black/5"><Icon className="h-6 w-6" /></div>
                      <h3 className="mt-5 text-lg font-bold text-slate-900">{b.title}</h3>
                      <p className="mt-2 text-slate-600">{b.text}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </AnimatedSection>

        {/* ===== FEATURES (playbooks style) ===== */}
        <AnimatedSection className="py-24 bg-white" id="features">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-end justify-between gap-6">
              <div>
                <h2 className="text-xs font-semibold tracking-[.25em] text-indigo-600 uppercase">Features</h2>
                <p className="mt-2 text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">Ship results, not tasks</p>
              </div>
              <div className="hidden md:flex gap-2 text-xs text-slate-500 ">
                <span className="px-2 py-1 rounded-full bg-slate-100 animate-pulse">Email</span>
                <span className="px-2 py-1 rounded-full bg-slate-100 animate-pulse">LinkedIn</span>
                <span className="px-2 py-1 rounded-full bg-slate-100 animate-pulse">Voice</span>
                <span className="px-2 py-1 rounded-full bg-slate-100 animate-pulse">Proposals</span>
              </div>
            </div>

            <div className="mt-12 grid lg:grid-cols-3 gap-6 ">
              {featuresContent.map((f, idx) => (
                <div key={f.id} className="relative group shadow-lg transform hover:scale-105 transition-transform duration-300">
                  <div className="absolute -inset-[1px] rounded-2xl bg-gradient-to-br from-indigo-500/20 via-fuchsia-500/20 to-purple-500/20 opacity-0 group-hover:opacity-100 transition" />
                  <div className="relative rounded-2xl bg-white ring-1 ring-slate-200 p-6 shadow-sm">
                    <div className="flex items-center gap-3">
                      <div className={`h-11 w-11 rounded-xl ${f.bgColor} ring-1 ring-black/5 flex items-center justify-center`}>
                        <f.Icon className={`h-5 w-5 ${f.iconColor}`} />
                      </div>
                      <h3 className="text-lg font-bold text-slate-900">{f.title}</h3> 
                    </div>
                    <p className="mt-3 text-slate-600">{f.description}</p>
                    <div className="mt-5 grid grid-cols-3 gap-2 text-xs text-slate-500">
                      <div className="rounded-lg bg-slate-50 px-3 py-2 ring-1 ring-slate-200">Setup</div>
                      <div className="rounded-lg bg-slate-50 px-3 py-2 ring-1 ring-slate-200">Draft</div>
                      <div className="rounded-lg bg-slate-50 px-3 py-2 ring-1 ring-slate-200">Launch</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </AnimatedSection>

        {/* ===== TESTIMONIALS ===== */}
        <AnimatedSection className="py-24 bg-slate-50" id="testimonials">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center max-w-3xl mx-auto">
              <h2 className="text-3xl font-extrabold tracking-tight text-slate-900">Loved by teams worldwide</h2>
              <p className="mt-3 text-slate-600">Real outcomes from real revenue teams.</p>
            </div>
            <div className="mt-12 grid gap-6 lg:grid-cols-3">
              {testimonials.items.map((t) => (
                <div key={t.id} className="relative rounded-2xl bg-white p-8 ring-1 ring-slate-200 shadow-lg">
                  <div className="flex items-center gap-2 mb-4">
                    {Array.from({ length: t.rating }).map((_, i) => <Star key={i} className="h-5 w-5 text-yellow-400" />)}
                  </div>
                  <p className="text-slate-700 text-lg">"{t.feedback}"</p>
                  <div className="mt-6 flex items-center gap-4">
                    <img src={t.avatarUrl} alt={t.name} className="w-12 h-12 rounded-full ring-2 ring-white" />
                    <div>
                      <p className="font-semibold text-slate-900">{t.name}</p>
                      <p className="text-xs text-slate-500">{t.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </AnimatedSection>

        {/* ===== INTEGRATIONS (horizontal rail) ===== */}
        <AnimatedSection className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between">
              <h3 className="text-xl font-bold text-slate-900">Works with your stack</h3>
              <p className="text-sm text-slate-500">Connect Roboman in seconds</p>
            </div>
            <div className="mt-6 flex gap-3 overflow-x-auto no-scrollbar">
              {['Gmail', 'Outlook', 'Salesforce', 'HubSpot', 'Zapier'].map((n, i) => (
                <div key={i} className="flex-shrink-0 rounded-2xl bg-slate-50 ring-1 ring-slate-200 px-5 py-3 text-slate-700 font-semibold">{n}</div>
              ))}
            </div>
          </div>
        </AnimatedSection>

        {/* ===== PRICING (ticket cards) =====
        <AnimatedSection className="py-24 bg-slate-50" id="pricing">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h2 className="text-3xl font-extrabold tracking-tight text-slate-900">Flexible credit packages</h2>
              <p className="mt-3 text-slate-600">One-time purchase, no subscriptions.</p>
              <div className="mt-6 inline-flex flex-wrap gap-2 p-1 bg-slate-200 rounded-full">
                {pricingData.currencies.map((c) => (
                  <button key={c.id} onClick={() => setSelectedCurrency(c.id)} className={`min-w-[9rem] text-sm font-semibold py-2 px-4 rounded-full transition ${selectedCurrency===c.id ? 'bg-white text-slate-900 shadow ring-1 ring-slate-200' : 'text-slate-600 hover:text-slate-900'}`}>{c.name}</button>
                ))}
              </div>
            </div>

            <div className="mt-12 grid lg:grid-cols-4 gap-6 items-stretch">
              {pricingData.plans.map((p)=> (
                <div key={p.id} className={`relative rounded-2xl bg-white ring-1 p-6 flex flex-col ${p.recommended? 'ring-indigo-500 shadow-2xl scale-[1.02]' : 'ring-slate-200 shadow-lg'}`}>
                  {p.recommended && <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-indigo-600 text-white text-[10px] font-semibold px-3 py-1 rounded-full uppercase tracking-wider">Most Popular</span>}
                  <div className="text-center">
                    <h3 className="text-xl font-bold text-slate-900">{p.title}</h3>
                    <p className="mt-3 text-4xl font-extrabold text-slate-900">
                      {p.prices[selectedCurrency] !== 'Custom' && pricingData.currencies.find(c => c.id === selectedCurrency).symbol}
                      {p.prices[selectedCurrency]}
                      {p.vat && p.vat[selectedCurrency] && <span className="text-sm font-medium text-slate-400">+VAT</span>}
                    </p>
                    <p className="text-sm font-semibold text-indigo-600">{p.credits} Credits</p>
                  </div>

                  {p.features && (
                    <div className="mt-6 border-t pt-6 space-y-2">
                      {p.features.map((f,i)=> (
                        <p key={i} className="text-slate-600 text-sm flex items-start justify-center"><span className="mr-2 mt-0.5"><CheckCircle className="h-4 w-4 text-emerald-500"/></span>{f}</p>
                      ))}
                    </div>
                  )}
                  {p.mixExample && (
                    <div className="mt-6 border-t pt-6 text-center">
                      <p className="text-xs font-bold text-slate-700">{p.mixExample.title}</p>
                      {p.mixExample.items.map((it, i)=> (<p key={i} className="text-[12px] text-slate-500">{it}</p>))}
                    </div>
                  )}
                  {p.priceInfo && <p className="text-center text-sm text-slate-500 mt-4">{p.priceInfo}</p>}

                  <div className="mt-auto pt-6">
                    <button onClick={() => navigate('/signup')} className={`w-full py-3 px-6 rounded-lg font-semibold transition-colors ${p.recommended ? 'bg-indigo-600 text-white hover:bg-indigo-700' : 'bg-indigo-50 text-indigo-700 hover:bg-indigo-100'}`}>
                      {p.title === 'Enterprise' ? 'Contact Sales' : 'Buy Credits'}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </AnimatedSection> */}

        <HomepagePricingSection />

        {/* ===== FINAL CTA ===== */}
        <AnimatedSection className="py-24">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="relative overflow-hidden rounded-3xl">
              <div className="absolute inset-0 bg-gradient-to-r from-indigo-600 via-violet-600 to-fuchsia-600" />
              <div className="absolute inset-0 opacity-25 grid-bg" />
              <div className="relative text-center p-12">
                <h2 className="text-4xl font-extrabold text-white tracking-tight">{finalCta.prompt}</h2>
                <button onClick={() => navigate('/signup')} className="mt-8 inline-flex items-center gap-2 group px-8 py-4 bg-white text-slate-900 font-bold rounded-full shadow-2xl ring-1 ring-slate-200 transition-transform duration-300 hover:scale-[1.03]">
                  {finalCta.buttonText}
                  <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
                </button>
                <p className="mt-4 text-sm text-indigo-50">{finalCta.note}</p>
              </div>
            </div>
          </div>
        </AnimatedSection>
      </main>

      <Footer />
    </div>
  );
};

export default HomePage;
